// extracted by mini-css-extract-plugin
export var deliveryRow = "_q0-a";
export var fixedHeight = "_q0-4";
export var freightLogo = "_q0-9";
export var fullWidth = "_q0-3";
export var priceColumn = "_q0-5";
export var radioSelected = "_q0-7";
export var radioUnselected = "_q0-6";
export var selectedOption = "_q0-2";
export var selectedOptionContainer = "_q0-1";
export var selection = "_q0-0";
export var tallSkeletonText = "_q0-8";